import i18n from "@/plugins/i18n";
import { filterCapitalize } from "@/filters/capitalize";

export enum MESSAGE_TYPES {
  Warning = "Warning",
  Success = "Success",
  Error = "Error",
}

export const messageTypesToName = (messageType: MESSAGE_TYPES): string => {
  if (messageType === MESSAGE_TYPES.Warning) {
    return filterCapitalize(i18n.t("warning"));
  }
  if (messageType === MESSAGE_TYPES.Success) {
    return filterCapitalize(i18n.t("success"));
  }
  if (messageType === MESSAGE_TYPES.Error) {
    return filterCapitalize(i18n.t("error"));
  }
  return "";
};
